import React from "react";
import Slider from "react-slick";
import { Slide, Fade } from "react-reveal";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { settingsrecent } from "../reusables/carouselrecent";
import cd2 from "../../assets/images/cultureday2025/cd2.jpg";
import cd4 from "../../assets/images/cultureday2025/cd4.jpg";
import cd5 from "../../assets/images/cultureday2025/cd5.jpg";
import cd6 from "../../assets/images/cultureday2025/cd6.jpg";
import cd7 from "../../assets/images/cultureday2025/cd7.jpg";
import cd8 from "../../assets/images/cultureday2025/cd8.jpg";
import cd23 from "../../assets/images/cultureday2025/cd23.jpg";
import cd25 from "../../assets/images/cultureday2025/cd25.jpg";
import cd52 from "../../assets/images/cultureday2025/cd52.jpg";
import cd58 from "../../assets/images/cultureday2025/cd58.jpg";
import cd60 from "../../assets/images/cultureday2025/cd60.jpg";
import cd62 from "../../assets/images/cultureday2025/cd62.jpg";
import s1 from "../../assets/images/2025/1.jpg";
import s2 from "../../assets/images/2025/2.jpg";
import s3 from "../../assets/images/2025/3.jpg";
import s4 from "../../assets/images/2025/4.jpg";
import s5 from "../../assets/images/2025/5.jpg";
import s6 from "../../assets/images/staffparty2024/6.jpg";
import s7 from "../../assets/images/staffparty2024/7.jpg";
import s8 from "../../assets/images/staffparty2024/8.jpg";
import s9 from "../../assets/images/staffparty2024/9.jpg";
import s10 from "../../assets/images/staffparty2024/10.jpg";
import s11 from "../../assets/images/2025/6.jpg";
import s12 from "../../assets/images/2025/7.jpg";
import s13 from "../../assets/images/2025/8.jpg";
import s14 from "../../assets/images/2025/9.jpg";
import s15 from "../../assets/images/2025/10.jpg";
import s16 from "../../assets/images/2025/11.jpg";
import s17 from "../../assets/images/2025/12.jpg";
import s18 from "../../assets/images/2025/13.jpg";
import s19 from "../../assets/images/2025/14.jpg";
import GalleryCard from "../reusables/GalleryCard";

const RecentEvents = () => {
  return (
    <section className="sections section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-content">
              <Slide top>
                <div className="section-head center">
                  <h3 className="text-shadow green">Recent Events in Photos</h3>
                  <p className=" margin-top-20 width-600 margin-auto section-spacing-20">
                    As it happened...
                  </p>
                </div>
              </Slide>
              <div className="section-body section-spacing-50 no-padding-top">
                <div className="slider-items-container gallery-container">
                  <Slider {...settingsrecent}>
                    <GalleryCard
                      galleryImage={s1}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s2}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s3}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s4}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s5}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s11}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s12}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s13}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s14}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s15}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s16}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s17}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s18}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={s19}
                      galleryImageCaption="KCG New Look 2025"
                    />
                    <GalleryCard
                      galleryImage={cd2}
                      galleryImageCaption="KCG Culture Day 2025"
                    />
                    <GalleryCard
                      galleryImage={cd4}
                      galleryImageCaption="KCG Culture Day 2025"
                    />
                    <GalleryCard
                      galleryImage={cd5}
                      galleryImageCaption="KCG Culture Day 2025"
                    />
                    <GalleryCard
                      galleryImage={cd52}
                      galleryImageCaption="KCG Culture Day 2025"
                    />
                    <GalleryCard
                      galleryImage={cd58}
                      galleryImageCaption="KCG Culture Day 2025"
                    />
                    <GalleryCard
                      galleryImage={cd6}
                      galleryImageCaption="KCG Culture Day 2025"
                    />
                    <GalleryCard
                      galleryImage={cd7}
                      galleryImageCaption="KCG Culture Day 2025"
                    />
                    <GalleryCard
                      galleryImage={cd8}
                      galleryImageCaption="KCG Culture Day 2025"
                    />
                    <GalleryCard
                      galleryImage={cd23}
                      galleryImageCaption="KCG Culture Day 2025"
                    />
                    <GalleryCard
                      galleryImage={cd25}
                      galleryImageCaption="KCG Culture Day 2025"
                    />
                    <GalleryCard
                      galleryImage={cd60}
                      galleryImageCaption="KCG Culture Day 2025"
                    />
                    <GalleryCard
                      galleryImage={cd62}
                      galleryImageCaption="KCG Culture Day 2025"
                    />
                    <GalleryCard
                      galleryImage={s6}
                      galleryImageCaption="End of Year Staff Party 2024"
                    />
                    <GalleryCard
                      galleryImage={s7}
                      galleryImageCaption="End of Year Staff Party 2024"
                    />
                    <GalleryCard
                      galleryImage={s8}
                      galleryImageCaption="End of Year Staff Party 2024"
                    />
                    <GalleryCard
                      galleryImage={s9}
                      galleryImageCaption="End of Year Staff Party 2024"
                    />
                    <GalleryCard
                      galleryImage={s10}
                      galleryImageCaption="End of Year Staff Party 2024"
                    />
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecentEvents;
